module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    Page not found.\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30a13a7e!./~/vue-loader/lib/selector.js?type=template&index=0!./public/src/pages/not_found.vue
// module id = 352
// module chunks = 0